var skierCodes = {1: 'A',2: 'B',3: 'C',4: 'D',5: 'E',6: 'F',7: 'G',8: 'H',9: 'I',10: 'J',11: 'K',12: 'L',13: 'M',14: 'N',15: 'O',16: 'P'}

var heights = {
  '2\'10" - 3\'2"': 8,
  '3\'3" - 3\'6"': 8,
  '3\'7" - 3\'10"': 8,
  '3\'11" - 4\'2"': 8,
  '4\'3" - 4\'6"': 8,
  '4\'7" - 4\'9"': 8,
  '4\'10" (147cm)': 8,
  '4\'11" (150cm)': 9,
  '5\'0" (152 cm)': 9,
  '5\'1" (155cm)': 9,
  '5\'2" (157cm)': 10,
  '5\'3" (160cm)': 10,
  '5\'4" (163cm)': 10,
  '5\'5" (165cm)': 10,
  '5\'6" (168cm)': 11,
  '5\'7" (170cm)': 11,
  '5\'8" (173cm)': 11,
  '5\'9" (175cm)': 11,
  '5\'10" (178cm)': 11,
  '5\'11" (180cm)': 12,
  '6\'0" (183cm)': 12,
  '6\'1" (185cm)': 12,
  '6\'2" (188cm)': 12,
  '6\'3" (191cm)': 12,
  '6\'4" (193cm)': 12,
  '6\'5" (196cm) or more': 13
};

var weights = {'22 - 29 lb': 1, '30 - 38 lb': 2, '39 - 47 lb': 3, '48 - 56 lb': 4, '57 - 66 lb': 5, '67 - 78 lb': 6, '79 - 91 lb': 7, '92 - 107 lb': 8, '108 - 125 lb': 9, '126 - 147 lb': 10, '148 - 174 lb': 11, '175 - 209 lb': 12, '210 lb +': 13};

var skierTypeModifier = {'Type 1 - Beginner': 0, 'Type 2 - Intermediate': 1, 'Type 3 - Advanced': 2};
var skierAgeModifier = {'2 - 10': -1, '11 - 49': 0, '50 and Above': -1 };

var DINMatrix = [
  ['¾', '¾', '¾', 'N/A', 'N/A', 'N/A', 'N/A', 'N/A'],
  ['1', '¾', '¾', '¾', 'N/A', 'N/A', 'N/A', 'N/A'],
  ['1½', '1¼', '1¼', '1', 'N/A', 'N/A', 'N/A', 'N/A'],
  ['2', '1¾', '1½', '1½', '1¼', 'N/A', 'N/A', 'N/A'],
  ['2½', '2¼', '2', '1¾', '1½', '1½', 'N/A', 'N/A'],
  ['3', '2¾', '2½', '2¼', '2', '1¾', '1¾', 'N/A'],
  ['N/A', '3½', '3', '2¾', '2½', '2¼', '2', 'N/A'],
  ['N/A', 'N/A', '3½', '3', '3', '2¾', '2½', 'N/A'],
  ['N/A', 'N/A', '4½', '4', '3½', '3½', '3', 'N/A'],
  ['N/A', 'N/A', '5½', '5', '4½', '4', '3½', '3'],
  ['N/A', 'N/A', '6½', '6', '5½', '5', '4½', '4'],
  ['N/A', 'N/A', '7½', '7', '6½', '6', '5½', '5'],
  ['N/A', 'N/A', 'N/A', '8½', '8', '7', '6½', '6'],
  ['N/A', 'N/A', 'N/A', '10', '9½', '8½', '8', '7½'],
  ['N/A', 'N/A', 'N/A', '11½', '11', '10', '9½', '9'],
  ['N/A', 'N/A', 'N/A', 'N/A', 'N/A', '12', '11', '10½']
]

var soleLengths = {
  '≤230mm': 0,
  '231-250mm': 1,
  '251-270mm': 2,
  '271-290mm': 3,
  '291-310mm': 4,
  '311-330mm': 5,
  '331-350mm': 6,
  '≥351mm': 7
};

var USToMondoPointSizeMapping = {
  1: 20.5,
  2: 21,
  3: 21.5,
  4: 22,
  4.5: 22.5,
  5: 23,
  5.5: 23.5,
  6: 24,
  6.5: 24.5,
  7: 25,
  7.5: 25.5,
  8: 26,
  8.5: 26.5,
  9: 27,
  9.5: 27.5,
  10: 28,
  10.5: 28.5,
  11: 29,
  11.5: 29.5,
  12: 30,
  12.5: 30.5,
  13: 31,
  13.5: 31.5,
  14: 32,
  14.5: 32.5,
  15: 33,
  15.5: 33.5,
  16: 34
};

var USToMondoPointSizeMapping_Kids = {
  '7 (Kids)': 14,
  '8 (Kids)': 15,
  '9 (Kids)': 16,
  '10 (Kids)': 17,
  '11 (Kids)': 17.5,
  '12 (Kids)': 18.5,
  '13 (Kids)': 19.5,
  '13.5 (Kids)': 20
};

function GetSkierCode(height, weight, skierType, age) {
  var skierCode = Math.min(heights[height.trim()], weights[weight]);
  skierCode += skierTypeModifier[skierType];
  skierCode += skierAgeModifier[age];
  return skierCode;
}

function GetMondopointSize(shoeSize, gender, age) {
  if (shoeSize.includes('Kids')) {
	return USToMondoPointSizeMapping_Kids[shoeSize];
  } else if (gender == 'Female') {
	return USToMondoPointSizeMapping[shoeSize - 1];
  }
  return USToMondoPointSizeMapping[shoeSize];
}

function EstimateBootSoleLength(shoeSize, gender, age) {
  var mondopointSize = GetMondopointSize(shoeSize, gender, age); 
  var soleLength = '';
  
  switch (true) {
	case (mondopointSize < 19):
	  soleLength = '≤230mm';
	  break;
	case (mondopointSize >= 19 && mondopointSize < 21.5):
	  soleLength = '231-250mm';
	  break;
	case (mondopointSize >= 21.5 && mondopointSize < 23):
	  soleLength = '251-270mm';
	  break;
	case (mondopointSize >= 23 && mondopointSize < 25.5):
	  soleLength = '271-290mm';
	  break;
	case (mondopointSize >= 25.5 && mondopointSize < 27.5):
	  soleLength = '291-310mm';
	  break;
	case (mondopointSize >= 27.5 && mondopointSize < 29.5):
	  soleLength = '311-330mm';
	  break;
	case (mondopointSize >= 29.5 && mondopointSize < 31):
	  soleLength = '331-350mm';
      break;
    case (mondopointSize >= 31):
      soleLength = '≥351mm';
      break;
    default:
      throw Exception(`Failed to estimate boot sole length with the following inputs: shoeSize = ${shoeSize}, gender = ${gender}, age = ${age}`)
  }

  return soleLength;
}

function CalculateDIN(skierCode, soleLength) {
  return DINMatrix[skierCode - 1][soleLengths[soleLength]];
}

async function fetchCartItems(){
  return await fetch(window.Shopify.routes.root + 'cart.js')
    .then(response => response.json())
    .then(cart => { return cart.items; });
}

async function fetchProductTags(handle){
  return await fetch(window.Shopify.routes.root + 'products/' + handle + '.js')
  .then(response => response.json())
  .then(product => {
    return product.tags;
  });
}

function updateCartItemDIN(item){
    var properties = item.properties;

    // Avoid POSTing change requests for items that have already been processed.
    if (properties['Skier Type'].includes('DIN')) {
      return;
    }
    
    var skierCode = GetSkierCode(properties.Height, properties.Weight, properties["Skier Type"], properties.Age);
    var estimatedBootSoleLength = EstimateBootSoleLength(properties["Shoe Size"], properties.Gender, properties.Age);
    var DIN = CalculateDIN(skierCode, estimatedBootSoleLength);
    

    if (Object.keys(skierTypeModifier).indexOf(properties['Skier Type']) > -1){
      properties['Skier Type'] = 'Type ' + (skierTypeModifier[properties['Skier Type']] + 1) + ', Code ' + skierCodes[skierCode] + ', DIN ' + DIN + ', ' + estimatedBootSoleLength;
    }    

    var formData = {
      'id': item.key,
      'properties': properties
    };

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });
}

fetchCartItems().then(cartItems => {
  cartItems.forEach(item => {
    if (item.product_type == "Rental"){
      fetchProductTags(item.handle).then(tags => {
        if (tags.includes('calculate-din')){
          item.tags = tags;
          updateCartItemDIN(item);
        }
      })
    }
  })
});